import { SystemState } from './types'

export const getCountValue = (state: SystemState) => state.count.value
